module.exports = __webpack_public_path__ + "static/media/sobe-eye-back.1462906b.webp";